module.exports = __webpack_public_path__ + "static/media/star_solo.d80c12e4.svg";